import {
	INVOICEABLE_BID_STATUSES,
	RESENDABLE_BID_STATUSES,
} from './actions';

export const ITEMIZED_BID_SYNC_ALLOWED_STATUSES = new Set([
	...RESENDABLE_BID_STATUSES,
	...INVOICEABLE_BID_STATUSES,
]);

export const isItemizedBidSyncable = (bid) =>
	Boolean(bid?.status) && ITEMIZED_BID_SYNC_ALLOWED_STATUSES.has(bid.status);
